'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'plane';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f072';
var svgPathData = ['M18.5 136l29.5 118.1 .5 1.9-30 120 33.9 0 61.6-77 2.4-3 395.8 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-395.8 0-2.4-3-61.6-77-33.9 0zM155.3 24l58.7 176 168 0-161.3-176-65.4 0zm0 464l65.4 0 161.3-176-168 0-58.7 176z', 'M512.2 200c30.9 0 56 25.1 56 56s-25.1 56-56 56l-108.5 0-173.6 189.4-2.4 2.6-94.6 0 3.5-10.5 60.5-181.5-73.1 0-61.6 77-2.4 3-62.1 0 2.5-9.9 31.5-126.1-31.5-126.1-2.5-9.9 62.1 0 2.4 3 61.6 77 73.1 0-60.5-181.5-3.5-10.5 94.6 0 2.4 2.6 173.6 189.4 108.5 0zM382.1 312l-168 0-58.7 176 65.4 0 161.3-176zM208.2 296l304 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-395.8 0-2.4-3-61.6-77-33.9 0 29.5 118.1 .5 1.9-30 120 33.9 0 61.6-77 2.4-3 91.8 0zM220.7 24l-65.4 0 58.7 176 168 0-161.3-176z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPlane = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;